module.exports = __webpack_public_path__ + "img/shogi_2021_pack_1_0009.3e23a1c3.png";